import { Loading } from '@on3/ui-lib/components/Loading';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { type ReactNode } from 'react';

interface RecurlyProps {
  children: ReactNode;
}

export const Recurly = ({ children }: RecurlyProps) => {
  return (
    <>
      {window?.recurly ? (
        <RecurlyProvider publicKey={process.env.NEXT_PUBLIC_RECURLY_KEY || ''}>
          <Elements>{children}</Elements>
        </RecurlyProvider>
      ) : (
        <Loading />
      )}
    </>
  );
};
